import $ from 'jquery'

window.addEventListener(
  'bookingHubPaymentStep',
  (event) => {
    const { mainEl, submit, paymentMethod } = event.detail

    if (paymentMethod !== 'local') return

    $(mainEl).on('click', '.bhub-local-payment-form', () => {
      submit().catch((err) => {
        alert(err.message)
      })
    })
  },
  { once: true }
)
